module.exports = __webpack_public_path__ + "static/media/gomunity_logo.d077be07.png";